exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Layout\n   ========================================================================== */\n.layout {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  overflow: hidden;\n  background: #f8f8f8; }\n\n/* ==========================================================================\n   Drawer\n   ========================================================================== */\n.drawer-overlay {\n  position: absolute;\n  top: 80px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n  transform: scale(0);\n  cursor: pointer;\n  will-change: transform; }\n\n.drawer-overlay--is-open {\n  transform: scale(1); }\n\n.drawer {\n  position: absolute;\n  top: 80px;\n  left: 0;\n  bottom: 0;\n  width: 260px;\n  background: #f7f5eb;\n  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 5px 0 rgba(0, 0, 0, 0.16);\n  overflow: hidden;\n  z-index: 10;\n  transform: translateX(-270px);\n  transition: transform 300ms linear 0ms;\n  will-change: transform;\n  max-height: 100%;\n  overflow-y: auto; }\n\n.drawer--is-open {\n  transform: translateX(0); }\n\n/* ==========================================================================\n   Page\n   ========================================================================== */\n.header + .page {\n  height: calc(100vh - 80px); }\n\n.page {\n  position: relative;\n  flex: 1 1 0;\n  padding-left: 0;\n  height: 100vh;\n  background: #f8f8f8;\n  overflow-x: hidden;\n  overflow-y: auto;\n  will-change: transform; }\n\n/* ==========================================================================\n   Section\n   ========================================================================== */\n.section {\n  width: 100%;\n  transition: transform 300ms linear 0ms;\n  will-change: transform; }\n\n.section__content {\n  margin: 0 auto; }\n\n/* Sizes\n   ========================================================================== */\n.section--content-size-default .section__content {\n  max-width: 1240px; }\n\n.section--content-size-expanded .section__content {\n  max-width: calc(100% - 260px); }\n\n/* Density\n   ========================================================================== */\n.section--density-none .section__content {\n  padding-left: 0;\n  padding-right: 0; }\n\n.section--density-cozy {\n  padding-top: 20px;\n  padding-bottom: 20px; }\n  .section--density-cozy .section__content {\n    padding-left: 20px;\n    padding-right: 20px; }\n\n/* Themes\n   ========================================================================== */\n.section--theme-white {\n  background-color: #fff; }\n\n.section--theme-dark {\n  background-color: #343230; }\n\n.section--theme-light {\n  background-color: #f2f2f2; }\n\n.section--theme-yellow {\n  background-color: #f7f5eb; }\n\n/* ==========================================================================\n   Media queries\n   ========================================================================== */\n@media (min-width: 1500px) {\n  .page--translate .section {\n    transform: translateX(130px); }\n  .drawer-overlay {\n    display: none; } }\n\n@media (max-width: 767px) {\n  .drawer,\n  .drawer-overlay {\n    top: 60px; }\n  .header + .page {\n    height: calc(100vh - 60px); }\n  .section--content-size-expanded .section__content {\n    max-width: 1240px; } }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};